import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/** Visible page numbers (or null for an ellipsis gap). */
export function buildCameraPageItems(current: number, total: number): Array<number | 'ellipsis'> {
  if (total <= 1) {
    return [1];
  }
  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages = new Set<number>([1, total, current]);
  if (current > 1) {
    pages.add(current - 1);
  }
  if (current < total) {
    pages.add(current + 1);
  }
  if (current <= 2) {
    pages.add(2);
    pages.add(3);
  }
  if (current >= total - 1) {
    pages.add(total - 1);
    pages.add(total - 2);
  }

  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const result: Array<number | 'ellipsis'> = [];
  let prev = 0;
  for (const page of sorted) {
    if (prev && page - prev > 1) {
      result.push('ellipsis');
    }
    result.push(page);
    prev = page;
  }
  return result;
}

@Component({
  selector: 'eventq-camera-pages',
  imports: [MatIcon],
  templateUrl: './camera-pages.html',
  styleUrl: './camera-pages.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqCameraPages {
  readonly page = input(1);
  readonly totalPages = input(1);

  readonly pageChange = output<number>();

  readonly items = computed(() => buildCameraPageItems(this.page(), this.totalPages()));

  goPrev(): void {
    if (this.page() > 1) {
      this.pageChange.emit(this.page() - 1);
    }
  }

  goNext(): void {
    if (this.page() < this.totalPages()) {
      this.pageChange.emit(this.page() + 1);
    }
  }

  goTo(page: number): void {
    if (page !== this.page()) {
      this.pageChange.emit(page);
    }
  }
}
